<template>

    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
        <p class="title"><strong>Pesquisa</strong></p>

        <form class="mt-1 w-full">
            <div class="flex flex-wrap mb-4 px-4">
                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.productType"
                    :multiple="true"
                    :options="options.productType"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Tipo" />
                
                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.zone"
                    :multiple="true"
                    :options="options.zoneSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Região" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.products"
                    :multiple="true"
                    :options="options.productSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Produto" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.city"
                    :multiple="true"
                    :options="options.citysSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Cidade" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.salesPromoter"
                    :multiple="true"
                    :options="options.salesPromoterSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Promoter" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.marketNetwork"
                    :multiple="true"
                    :options="options.marketNetworkSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Rede" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.market"
                    :multiple="true"
                    :options="options.marketSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Loja" />

                <text-input 
                    v-model="filters.ShelfLifeRulesDashboard.minQuantity" 
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Quantidade Mínima" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.provider"
                    :multiple="true"
                    :options="options.providerSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Fornecedor" />

                <multi-select-input
                    v-model="filters.ShelfLifeRulesDashboard.brand"
                    :multiple="true"
                    :options="options.brandSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Marca" />

                <date-input 
                    v-model="filters.ShelfLifeRulesDashboard.dateStartActivity" 
                    class="lg:pr-6 w-full lg:w-1/4" 
                    label="Data Inicial da Atividade" />

                <date-input 
                    v-model="filters.ShelfLifeRulesDashboard.dateEndActivity" 
                    class="lg:pr-6 w-full lg:w-1/4" 
                    label="Data Final da Atividade" />

                <date-input 
                    v-model="filters.ShelfLifeRulesDashboard.dateStartShelfLife" 
                    class="lg:pr-6 w-full lg:w-1/4" 
                    label="Data Inicial da Validade" />

                <date-input 
                    v-model="filters.ShelfLifeRulesDashboard.dateEndShelfLife" 
                    class="lg:pr-6 w-full lg:w-1/4" 
                    label="Data Final da Validade" />
                
            </div>

            <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                <button
                    class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out "
                    @click.submit.prevent="filtersResults">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                </button>

                <button type="button"
                    class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100"
                    @click.submit.prevent="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                </button>
            </div>
        </form>
    </div>

    <div class="shadow_box rounded-lg p-6 relative mt-10">
        <div class="text-right w-full">
            <button 
                class="inline-block text-center w-[150px] py-3 px-4 btn-purple"
                @click="handlerExportXlsx">
                    <font-awesome-icon 
                        icon="fa-table-cells" 
                        class="text-purple text-sm mr-0 lg:mr-2" />

                    Exportar xlsx
            </button>
        </div>

        <data-table
            v-if="loadTable"
            v-model:columns="columns" 
            route="shelf_life_rule_dashboard/products/historic"
            no-data-label="Nenhum registro encontrado"
            no-result-label="Nenhum registro encontrado" 
            :query="getQuery"
            class="data-table">
        </data-table>
    </div>

    <Modal
        size="modal-lg"
        ref="showModalXlsx">
            <template #header>
                <div class="text-gray-777 font-roboto uppercase w-full">
                    Historico de arquivos xlsx exportados
                </div>
            </template>

            <template #body>
                <p>Deseja exportar um novo arquivo? </p>
                <button 
                    class="inline-block text-center w-[150px] py-3 px-4 btn-purple mt-4"
                    @click="handlerSendToExportData">
                        <font-awesome-icon 
                            icon="fa-table-cells" 
                            class="text-purple text-sm mr-0 lg:mr-2" />

                        Exportar 
                </button>

                <data-table
                    v-if="exportedTable"
                    v-model:columns="columnsExported" 
                    route="shelf_life_rule_dashboard/export"
                    no-data-label="Nenhum registro encontrado"
                    no-result-label="Nenhum registro encontrado"
                    class="data-table">

                    <template #table.cell.content.actions="{ value, row }">
                        <button 
                            @click="downloadExportedFile(row.id)" 
                            class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm mr-4">
                                <font-awesome-icon icon="fa-download" class="text-white px-2" />
                        </button>

                        <button 
                            @click="deleteExportedFile(row.id)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                                <font-awesome-icon icon="fa-trash-can" class="text-white px-2" />
                        </button>
                    </template>
                </data-table>
            </template>
            <template #footer>
                <button type="button"
                    class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                    @click.prevent="closeModalHistoric">Cancelar</button>
                
            </template>
    </Modal>
</template>


<script>


import { Link, Head } from '@inertiajs/inertia-vue3'


import SelectInput from '@/Shared/SelectInput.vue'
import Tabs from '@/Shared/Tabs/Tabs.vue'
import DataTable from '@/Shared/DataTable'
import BarChart from '@/Shared/BarChart'

import MultiSelectInput from '@/Shared/MultiSelectInput'
import TextInput from '@/Shared/TextInput'
import DateInput from '@/Shared/DateInput'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'

import Modal from '@/Shared/Modal'
import axios from 'axios'


export default {
    components: {
        SelectInput,
        Tabs,
        Link,
        Head,
        DataTable,
        BarChart,

        Modal,

        MultiSelectInput,
        TextInput,
        DateInput,
    },

    data() {
        return {
            loadTable: true,
            exportedTable: true,

            columnsExported: [
                {
                    uniqid: 'date',
                    label: 'Gerado',
                    field: 'created_at',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const createdAt = new Date(val)
                        return createdAt.toLocaleString('pt-br');
                    },
                },
                {
                    uniqid: 'title',
                    label: 'Nome',
                    field: 'title',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                },

                {
                    uniqid: 'status',
                    label: 'Status',
                    field: 'status',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const status = {
                            finish: 'Sucesso',
                            failed: 'Falhou',
                            processing: 'Processando',
                        }

                        return status[val]
                    }
                },

                {
                    uniqid: 'size',
                    label: 'Tamanho',
                    field: 'size',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        if (row.file)
                            return `${ (row.file.size / (1024 * 1024)).toFixed(2) }MB`
                    }
                },

                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'actions',
                    visible: true,
                    sortable: false,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                },
            ],

            columns: [
                {
                    uniqid: 'date',
                    label: 'Validade',
                    field: 'date',
                    visible: true,
                    sortable: true,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const createdAt = new Date(val)
                        return createdAt.toLocaleDateString('pt-br');
                    },
                },
                {
                    uniqid: 'establishment',
                    label: 'Estabelecimento',
                    field: 'establishment',
                    visible: true,
                    sortable: false,
                    classes: 'px-4 py-3 border-b text-sm col-login',
                    headerClass: 'p-4 text-left',

                    format: (val, row) => `${row.market_network} - ${row.market_name}`
                },
                {
                    uniqid: 'product',
                    label: 'Produto',
                    field: 'product_name',
                    visible: true,
                    sortable: false,
                    classes: 'px-4 py-3 border-b text-sm col-pix whitespace-nowrap overflow-hidden text-ellipsis',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'promoter_name',
                    label: 'Responsável',
                    field: 'promoter_name',
                    visible: true,
                    sortable: false,
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'created_at',
                    label: 'Data da Atividade',
                    field: 'created_at',
                    visible: true,
                    sortable: false,
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const createdAt = new Date(val)
                        return createdAt.toLocaleDateString('pt-br');
                    },
                },
                {
                    uniqid: 'quantity',
                    label: 'Quantidade',
                    field: 'inform_quantity',
                    visible: true,
                    sortable: false,
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.inform_quantity ?? '0'
                },
            ],

            options: {
                productType: [
                    { label: 'Produtos Coletados', value: 1 },
                    { label: 'Produtos Perdidos', value: 0 },
                ],

                minQuantity: 0,

                salesPromoterSearch: [],
                marketNetworkSearch: [],
                marketSearch: [],
                providerSearch: [],
                brandSearch: [],
                productSearch: [],
                statesSearch: [],
                citysSearch: [],
                zoneSearch: [],
            },
        }
    },

    mixins: [
        getFiltersMixin,
    ],

    watch: {
        'filters.ShelfLifeRulesDashboard': {
            handler() {
                this.getFiltersFromAPI()
            },
            deep: true,
        },
    },


    methods: {
        clearSearch () {
            this.clearFilters()
            this.getFiltersFromAPI()
            this.reloadTable()
        },

        reloadTable() {
            this.loadTable = false;
            setTimeout(() => this.loadTable = true, 10);
        },

        reloadExportedTable() {
            this.exportedTable = false;
            setTimeout(() => this.exportedTable = true, 10);
        },

        filtersResults() {
            this.reloadTable()
        },

        handlerExportXlsx(value = true) {
            this.$refs.showModalXlsx.showModal = value
        },
        closeModalHistoric() {
            this.$refs.showModalXlsx.showModal = false;
        },

        async handlerSendToExportData() {
            const filters = this.getFilters()

            try {

                const response = await axios.post('/shelf_life_rule_dashboard/export/xlsx', filters)

                if (response.status == 200)
                    this.$toast.success(response.data.message)
            }

            catch (err) {
                if (axios.isAxiosError(err))
                    this.$toast.error(err.response.data.message)

                else
                    this.$toast.error('Erro ao fazer requisição')
            }

            this.handlerExportXlsx(false)
        },


        downloadExportedFile(id) {
            window.open(`/shelf_life_rule_dashboard/export/xlsx/download/${id}`)
        },

        async deleteExportedFile(id) {
            try {
                const response = await axios.delete(`/shelf_life_rule_dashboard/export/xlsx/${id}`)

                if (response.status == 200)
                    this.$toast.success(response.data.message)
            }

            catch (err) {
                if (axios.isAxiosError(err))
                    this.$toast.error(err.response.data.message)

                else
                    this.$toast.error('Erro ao fazer requisição')
            }

            this.reloadExportedTable()
        },
    },

    computed: {
        getQuery() {
            return Object.entries( this.getFilters() ).map( ( [key, val] ) => `search2[${key}]=${val}` ).join( '&' )
        },
    },

    setup() {

        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent( 'ShelfLifeRulesDashboard' )

        const clearFilters = () => clearFiltersComponent( 'ShelfLifeRulesDashboard' )
        const getFilters = () => getFiltersComponent( 'ShelfLifeRulesDashboard' )


        return {
            getFilters,
            clearFilters, 
            filters: filtersStore.filters,
        }
    },
}

</script>
